import cx from 'classnames';
import { useDroppable } from '@dnd-kit/core';
import { DraggableWord } from './DraggableWord';
import { WORD_BANK_DROPZONE_ID } from 'core/constants';
import style from './style.scss';
/* eslint-disable react/prop-types */ // TODO: add props

export const DraggableWordBank = ({ words, disabled }) => {
  const { isOver, setNodeRef } = useDroppable({
    id: WORD_BANK_DROPZONE_ID,
    disabled,
  });

  return (
    <div
      className={cx(style.wordBank, { [style.wordBankIsOver]: isOver })}
      ref={setNodeRef}
    >
      <label>Word bank</label>
      <div className={style.wordBankWordList}>
        {words.map((item, index) => {
          const itemKey = `word_bank_item_${index}`;
          return (
            <DraggableWord id={itemKey} key={itemKey} disabled={disabled}>
              {item}
            </DraggableWord>
          );
        })}
      </div>
    </div>
  );
};
